import { useMemo } from 'react';
import { useGetFullBalance } from 'react-easyrocket';
import { ONE_MINUTE_MS } from 'src/constants';

// массив игр с wager
export function useGetUserBonusGames() {
  const { bonusAccountCasino } = useGetFullBalance({
    staleTime: ONE_MINUTE_MS,
    cacheTime: ONE_MINUTE_MS
  });

  const userBonusGames = useMemo(() => {
    return bonusAccountCasino?.wager?.bonus
      ? bonusAccountCasino.wager.bonus?.wageringGames
      : undefined;
  }, [bonusAccountCasino]);

  return { userBonusGames };
}
